<div class="px-3 pt-3 pb-3">
  <app-inline-filter-card (onApply)="filterCardData$.next($event)"></app-inline-filter-card>
  <mat-card>
    <mat-card-content class="p-0">
      <app-datatable
        [configurationInput]="datatableConfigurations"
        [rowData]="store.data$()"
        [columns]="datatableColumns"
        [total]="this.store.dataTotal$()"
        [customColumnDef]="[
          { name: 'name', template: isNameCell, isSortable: true },
          { name: 'isActive', template: isActiveCell, isSortable: true },
        ]"
        (deleteClick)="selectedDatatableItems().length >= 2 ? initializeBulkDelete() : initializeDelete()"
        (editClick)="initializeEdit()"
        (addClick)="initializeAdd()"
        (dataRefreshRequest)="datatableParams$.next($event)"
        (selectedItemsChange)="selectedDatatableItems.set($event)"
      />
    </mat-card-content>
  </mat-card>
</div>
<ng-template #isNameCell let-row="row">
  {{ row.isDefault ? ('system.label.' + row.name | translate) : row.name }}
  <mat-chip *ngIf="row.isDefault" class="chip-hover-remove" [disableRipple]="true">
    {{ 'system.label.default' | translate | uppercase }}</mat-chip
  >
</ng-template>

<ng-template #isActiveCell let-row="row">
  <mat-chip [ngClass]="row.isActive ? 'green' : 'red'" class="chip-hover-remove" [disableRipple]="true">
    {{ (row.isActive ? 'button.active' : 'button.inactive') | translate | uppercase }}
  </mat-chip>
</ng-template>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()">
    <div mat-dialog-content>
      <div class="row">
        <mat-form-field appearance="outline" *ngIf="!isBulkEdit()">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.get('name')"></mat-error>
        </mat-form-field>
        <div class="bulk-dialog-field">
          <mat-checkbox
            *ngIf="isBulkEdit()"
            (change)="formService.toggleBulkCheckbox($event, addEditForm.get('isActive'))"
          >
          </mat-checkbox>
          <mat-checkbox formControlName="isActive">
            {{ 'field.active' | translate }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
